const hasRoles = (roles) => {
  return {
    getRoleNames() {
      return roles.reduce((accumulator, role) => {
        return accumulator === '' ? role.name : `${accumulator}, ${role.name}`;
      }, '');
    },
  };
};

export default hasRoles;
